import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const NakladoveStrediskoTyp = {
	name: NAME,
	apiProvider,
	router,
};
